import { required, schemaCommon } from "components/Reusable/Bit/FormikSchema"
import * as yup from "yup"

type validationProps = {
  min?: number
  max?: number
}

const validationSchema = ({ min, max }: validationProps) => {
  return yup.object({
    amount: yup
      .number()
      .min(min, `ניתן להכניס סכום מינימלי של לפחות ${min} ש״ח`)
      .max(max, `ניתן להכניס סכום מקסימלי של ${max} ש״ח`)
      .typeError("יש להזין מספר בלבד")
      .required(required.default),
    RecipientName: schemaCommon.fullName,
    RecipientMobilePhone: schemaCommon.phoneNumber,
    RecipientEmail: schemaCommon.recipientEmail,
    SenderName: schemaCommon.fullName,
    SenderLastName: schemaCommon.fullName,
    SenderMobilePhone: schemaCommon.phoneNumber,
    SenderEmail: schemaCommon.email,
    checkedOne: schemaCommon.checkbox,
  })
}

export default validationSchema
